import React from 'react';
import { Chrome, MessageCircle, Zap, Shield } from 'lucide-react';
import {
  AuthContainer,
  BackgroundEffect,
  BlurOrb,
  MainContent,
  BrandSection,
  LogoContainer,
  LogoImage,
  BrandTitle,
  BrandSubtitle,
  AuthCard,
  WelcomeSection,
  WelcomeTitle,
  WelcomeSubtitle,
  GoogleButton,
  GoogleIcon,
  ButtonText,
  ZapIcon,
  FeaturesSection,
  FeatureItem,
  FeatureIcon,
  FeatureText,
  Footer,
  FooterText,
  FooterLink,
  DecorativeCircle,
  DecorativeDot,
  LoadingContainer,
  LoadingSpinner,
  LoadingText
} from './styles';

interface AuthProps {
  onLogin: () => void;
}

const LOGO_SRC = "/logo.png"

const Auth: React.FC<AuthProps> = ({ onLogin }) => {
  return (
    <AuthContainer>
      <BackgroundEffect>
        <BlurOrb color="purple" top="-10rem" right="-10rem" delay="0s" />
        <BlurOrb color="pink" bottom="-10rem" left="-10rem" delay="1s" />
        <BlurOrb color="indigo" top="10rem" left="10rem" delay="2s" />
      </BackgroundEffect>

      <MainContent>
        <BrandSection>
          <LogoContainer>
            <LogoImage src={LOGO_SRC} />
          </LogoContainer>
          <BrandTitle>Infinity</BrandTitle>
          <BrandSubtitle>Connect. Chat. Create.</BrandSubtitle>
        </BrandSection>

        <AuthCard>
          <WelcomeSection>
            <WelcomeTitle>Welcome Back</WelcomeTitle>
            <WelcomeSubtitle>Sign in to continue your conversations</WelcomeSubtitle>
          </WelcomeSection>

          <GoogleButton onClick={onLogin}>
            <GoogleIcon>
              <Chrome size={16} color="white" />
            </GoogleIcon>
            <ButtonText>Continue with Google</ButtonText>
            <ZapIcon>
              <Zap size={20} />
            </ZapIcon>
          </GoogleButton>

          <FeaturesSection>
            <FeatureItem>
              <FeatureIcon color="#10B981">
                <Shield size={20} />
              </FeatureIcon>
              <FeatureText>Secure authentication</FeatureText>
            </FeatureItem>
            <FeatureItem>
              <FeatureIcon color="#8B5CF6">
                <MessageCircle size={20} />
              </FeatureIcon>
              <FeatureText>Real-time messaging</FeatureText>
            </FeatureItem>
          </FeaturesSection>
        </AuthCard>

        <Footer>
          <FooterText>
            By continuing, you agree to our{' '}
            <FooterLink href="#">Terms of Service</FooterLink>
            {' '}and{' '}
            <FooterLink href="#">Privacy Policy</FooterLink>
          </FooterText>
        </Footer>
      </MainContent>

      <DecorativeCircle size="6rem" top="1rem" left="1rem" opacity={0.2} />
      <DecorativeCircle size="8rem" bottom="1rem" right="1rem" opacity={0.1} />
      <DecorativeDot size="0.5rem" top="33%" right="2rem" color="white" animation="ping" />
      <DecorativeDot size="0.75rem" bottom="33%" left="2rem" color="#8B5CF6" animation="pulse" />
    </AuthContainer>
  );
};

export const AuthLoading: React.FC = () => (
  <LoadingContainer>
    <div>
      <LoadingSpinner />
      <LoadingText>Loading...</LoadingText>
    </div>
  </LoadingContainer>
);

export default Auth;